import apiTariff from '@/api/tariff'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  createTariffStart: '[create tariff] Create tariff start',
  createTariffSuccess: '[create tariff] Create tariff success',
  createTariffFailure: '[create tariff] Create tariff failure'
}

export const actionTypes = {
  createTariff: '[create tariff] Create tariff'
}

const mutations = {
  [mutationTypes.createTariffStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createTariffSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createTariffFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.createTariff](context, tariff) {
    context.commit(mutationTypes.createTariffStart)
    return new Promise(resolve => {
      apiTariff
        .createTariff(tariff)
        .then(response => {
          context.commit(mutationTypes.createTariffSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.createTariffFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
